import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ costProfile, nextCostProfile }) =>
    present(
      repository
        .updateCostProfile(costProfile, nextCostProfile)
        .catch(() => Promise.reject({ costProfile, nextCostProfile })),
    );
}

export type { Interactor };

export { createInteractor };
